import React, { Component } from 'react';
import { connect } from 'react-redux';
import { UserManager } from '../../../utils';
import { trueFalseToBoolean, setUserTestHarness } from '../../../utils/helpers.utils';
import { setAuthToken } from '../../../utils/api.utils'
import { NODE_ENVIRONMENTS as nodeEnv, LOGIN_STATUS as loginStat} from '../../../utils/constant.utils';

class ExternalAuthentication extends Component {
    constructor(props) {
        super();
        this.state = {
            userName: ""
        };
    }

    componentDidMount() {
        this.authorizeUser();
        sessionStorage.setItem("logInStatus", loginStat.external);
        localStorage.setItem("logInStatus", loginStat.external)
    }

    componentDidUpdate(prevProps) {
        if (this.props.isOidcLoadingUser !== prevProps.isOidcLoadingUser) {
            this.authorizeUser();
            sessionStorage.setItem("logInStatus", loginStat.external);
            localStorage.setItem("logInStatus", loginStat.external);
        }
    }

    authorizeUser = () => {
        if (process.env.NODE_ENV === nodeEnv.dev) {
            if (this.props.user != null) {
                var userName = typeof(Storage) !== "undefined" ? sessionStorage.getItem("EnterpriseID") : null;
                if (userName !== null && userName !== "") {
                    setAuthToken(userName);
                    this.props.dispatch(setUserTestHarness(userName));
                }
            }
        }
        if (process.env.NODE_ENV !== nodeEnv.dev && trueFalseToBoolean(process.env.REACT_APP_AAD_AUTH_ENABLE)) {
            this.redirectToAuth(this.props);
        } 
    }

    redirectToAuth = (props) => {
        var user = props.user;
        if (user !== null) {
            if (user.expired) {
                this.setEntryPathName(props);
                UserManager.signinRedirect();
            }
        } else {
            if (!props.isOidcLoadingUser) {
                this.setEntryPathName(props);
                UserManager.signinRedirect();
            }
        }
    }

    getLastLocation = (props) => {
        var lastLocation = props.location.pathname;
        return lastLocation;
    }

    setEntryPathName = (props) => {
        var lastLocation = this.getLastLocation(props);
        if (typeof (Storage) !== "undefined") {
            sessionStorage.setItem("EntryPathName", lastLocation);
        }
    }

    render() {
        return (
            <div></div>
        );
    }
}

function mapStateToProps(state) {
    return {
        user: (process.env.NODE_ENV === nodeEnv.dev) ? state.userTestHarness : state.oidc.user,
        isOidcLoadingUser: (process.env.NODE_ENV === nodeEnv.dev) ? false : state.oidc.isLoadingUser
    };
}

function mapDispatchToProps(dispatch) {
    return {
        dispatch
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(ExternalAuthentication);